import { useState, useEffect } from "react";
import { Menu } from "lucide-react";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";

const Header = ({ onOpenModal }) => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navItems = [
    { label: "Megoldás", href: "#megoldas" },
    { label: "Mit kapsz?", href: "#mit-kapsz" },
    { label: "Folyamat", href: "#folyamat" },
    { label: "Árak", href: "#csomagok" },
    { label: "Karbantartás", href: "#karbantartas" },
    { label: "GYIK", href: "#gyik" },
    { label: "Kapcsolat", href: "#kapcsolat" }
  ];

  return (
    <header
      data-testid="header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-ink py-3 border-b border-white/10" : "bg-ink py-5"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between">
        <a href="#" data-testid="logo" aria-label="LandingLab - Főoldal">
          <img 
            src="/logo.svg" 
            alt="LandingLab - profi weboldal készítés logó" 
            className="h-8 md:h-10 w-auto relative z-10"
            width="140"
            height="25"
            fetchPriority="high"
          />
        </a>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-8">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="hover:text-on-dark transition-colors !text-sm text-on-dark/70"
              data-testid={`nav-${item.href.slice(1)}`}
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:block">
          <button
            onClick={onOpenModal}
            className="bg-primary hover:bg-primary-hover text-white rounded-full px-6 py-2.5 text-sm font-semibold transition-all shadow-glow hover:shadow-glow-lg btn-glow"
            data-testid="header-cta"
          >
            Kérek egy gyors ajánlatot
          </button>
        </div>

        {/* Mobile Menu */}
        <Sheet open={mobileMenuOpen} onOpenChange={setMobileMenuOpen}>
          <SheetTrigger asChild className="lg:hidden">
            <button className="text-on-dark p-2" data-testid="mobile-menu-toggle" aria-label="Menü megnyitása">
              <Menu size={24} />
            </button>
          </SheetTrigger>
          <SheetContent side="right" className="bg-ink border-white/10 w-[280px]">
            <nav className="flex flex-col gap-4 mt-8">
              {navItems.map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={() => setMobileMenuOpen(false)}
                  className="text-on-dark/80 hover:text-on-dark py-2 transition-colors"
                >
                  {item.label}
                </a>
              ))}
              <button
                onClick={() => {
                  setMobileMenuOpen(false);
                  onOpenModal();
                }}
                className="bg-primary text-white rounded-full px-6 py-3 mt-4 font-semibold"
              >
                Kérek egy gyors ajánlatot
              </button>
            </nav>
          </SheetContent>
        </Sheet>
      </div>
    </header>
  );
};

export default Header;
